const a = {
  id: {
    NAVIGATION_MENU: "navigationMenu",
    SEARCH: "search"
  }
};
export {
  a as default
};
